import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Layout extends PureComponent {
  render() {
    const {
      children,
      // loading,
    } = this.props;

    return <>{children}</>;
  }
}

Layout.defaultProps = {
  loading: false,
};

Layout.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
};

export default Layout;
